export const SAVE_ADVERTISES = 'SAVE_ADVERTISES';
export const SAVE_CURRENT_ADVERTISE = 'SAVE_CURRENT_ADVERTISE';